import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    height: 70px;
    border: 1px solid #e1e1e1;
    align-items: center;
    border-radius: 4px;
    padding: 0px 20px;
    gap: 10px;
    font-size: 14px;
    cursor: pointer;
    margin-top: 20px;
    position: relative;
    z-index: 1;

    label{
        cursor: pointer;
    }
`

export const BarDivider = styled.div`
    display: flex;
    min-width: 1px;
    height: 20px;
    background-color: #e1e1e1;
    
`